import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { stepperClasses, svgIconClasses, stepLabelClasses, stepIconClasses, stepButtonClasses, Box, Stepper as Stepper$1, Step } from '@mui/material';
import { Typography } from '../Typography/Typography.js';
import { StepButton } from '../StepButton/StepButton.js';
import { theme, archerConstants } from '../../utils/themeProvider.js';
import '@mui/styles';
import '@mui/material/styles';
import 'uuid/v4';

var _stepperWrapper;

var isActive = function isActive(index, activeStep) {
  return index === activeStep;
};

var styles = {
  stepperWrapper: (_stepperWrapper = {
    backgroundColor: 'inherit'
  }, _defineProperty(_stepperWrapper, "& .".concat(stepperClasses['root']), {
    padding: 1
  }), _defineProperty(_stepperWrapper, "& .".concat(svgIconClasses['root']), {
    height: theme.spacing(3),
    width: theme.spacing(3)
  }), _defineProperty(_stepperWrapper, "& .".concat(stepLabelClasses['iconContainer']), _defineProperty({}, "& .".concat(stepIconClasses['text']), {
    fontSize: '16px !important',
    transform: 'translate(0px, 2px)'
  })), _defineProperty(_stepperWrapper, "& .".concat(stepButtonClasses['root']), {
    '&:focus, &:active': {
      backgroundColor: 'transparent'
    }
  }), _stepperWrapper),
  stepLabelContent: {
    fontSize: theme.spacing(2),
    lineHeight: 1.5
  },
  stepButtonRipple: _defineProperty({}, "& .".concat(stepButtonClasses['touchRipple']), {
    color: archerConstants.archerButtonActive
  })
};

var Stepper = function Stepper(_ref) {
  var sx = _ref.sx,
      orientation = _ref.orientation,
      nonLinear = _ref.nonLinear,
      steps = _ref.steps,
      completed = _ref.completed,
      activeStep = _ref.activeStep,
      className = _ref.className,
      onStepClick = _ref.onStepClick,
      focusRipple = _ref.focusRipple,
      _ref$disableRipple = _ref.disableRipple,
      disableRipple = _ref$disableRipple === void 0 ? false : _ref$disableRipple;
  var stepperWrapper = styles.stepperWrapper,
      stepLabelContent = styles.stepLabelContent,
      stepButtonRipple = styles.stepButtonRipple;

  function isStepComplete(step) {
    return completed.includes(step);
  }

  return /*#__PURE__*/React.createElement(Box, {
    sx: stepperWrapper
  }, /*#__PURE__*/React.createElement(Stepper$1, {
    sx: sx,
    alternativeLabel: true,
    className: className,
    activeStep: activeStep,
    orientation: orientation,
    nonLinear: nonLinear
  }, steps.map(function (label, index) {
    return /*#__PURE__*/React.createElement(Step, {
      key: label,
      active: isActive(index, activeStep),
      completed: isStepComplete(index),
      sx: stepButtonRipple
    }, /*#__PURE__*/React.createElement(StepButton, {
      focusRipple: focusRipple || false,
      onClick: function onClick() {
        return onStepClick(index);
      },
      icon: index + 1,
      disableRipple: disableRipple
    }, /*#__PURE__*/React.createElement(Typography, {
      sx: stepLabelContent,
      variant: isActive(index, activeStep) ? 'h4' : 'body1',
      color: function () {
        if (isActive(index, activeStep)) {
          return 'primary';
        }

        if (isStepComplete(index)) {
          return 'textPrimary';
        }

        return 'textSecondary';
      }()
    }, label)));
  })));
};

Stepper.defaultProps = {
  completed: [],
  orientation: 'horizontal',
  activeStep: 0
};
Stepper.displayName = 'Stepper';
export { Stepper };